// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4cdc2a05","553":"bff6c9ab","977":"819d99ad"}[chunkId] + ".chunk.js";
};